import { SelectionOptions } from '../../../gridView/types';

export enum SelectExtraOptionsEvents {
  EXTRA_OPTION_SELECTION_CHANGE = 'extraOptionSelectionChange',
}

export const SelectionOptionsArray = [
  { title: 'ALL', value: SelectionOptions.ALL },
  { title: 'All_FROM_PAGE', value: SelectionOptions.All_FROM_PAGE },
];
